import React, { useContext, useEffect, useState } from "react";
// import img from "../../Images/Ellipse 1588.png";
import img from "../../Images/winners.png";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import { Context } from "../..";
import { Link, useLocation, useNavigate } from "react-router-dom";
const BlogPost = () => {
  const [blogs, setBlogs] = useState([]);
  const [blogFetchCount, setBlogFetchCount] = useState(6);
  const [totalBlogCount, setTotalBlogCount] = useState(0);
  // const { setContextBlogs, contextBlogs } = useContext(Context);
  const navigateTo = useNavigate();

  const location = useLocation()
  const { blogCategory,blogCategoryName } = location?.state || {};
  console.log("CVT17", blogCategory);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await HomeService.getBlogs(blogFetchCount);

        let blogData=res.data||[]
        if(blogCategory){
          blogData=blogData.filter(item=>item?.category?._id===blogCategory)
        }
        //console.log(blogFetchCount);
        //console.log(res);
        setBlogs(blogData);

        setTotalBlogCount(res.pagination.totalData);
        //console.log("setContextBlogs", res.data);
      } catch (error) {
        console.error("error in fetching Blogs", error);
        toast.error("Error Fetching Blogs!");
      }
    };

    fetchBlogs();
  }, [blogFetchCount]);

  const handleLoadMore = () => {
    setBlogFetchCount(blogFetchCount + 3);
  };

  const handleClickOnBlog = (data) => {
    navigateTo("/blog-details", { state: { data } });
  };

  return (
    <>
      <div className="blog_post_wrapper">
        <h2 className="prefered_cities_head">{blogCategoryName ? blogCategoryName:"Recent"} Blog Post</h2>
        <div className="blog_card_wrapper">
          {blogs.map((e, i) => {
            const rawDate = e.createdOn;
            const stringDate = rawDate.split("T")[0];
            const date = new Date(stringDate);
            const finalDate = date.toLocaleDateString("en-GB", {
              day: "2-digit", // Day with leading zero if needed
              month: "long", // Full month name
              year: "numeric", // Full year
            });
            return (
              <>
                <div
                  style={{ cursor: "pointer" }}
                  className="blog_card"
                  key={i}
                  onClick={() => {
                    handleClickOnBlog(e);
                  }}
                >
                  <div className="blog_card_img">
                    <img src={e.image} alt="blogs" />
                  </div>
                  <div className="blog_information_div">
                    <h6>{e.title}</h6>
                    <p>{e.description.slice(0, 50)}</p>
                    <div className="blog_card_footer">
                      <img src={img} alt="author" />
                      <h4>Winners . {finalDate}</h4>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>

        <div className="button_wrapper_blog d-flex justify-content-center mt-5">
          {totalBlogCount > 6 && blogFetchCount < totalBlogCount ? (
            <button className="discover_btn_5" onClick={handleLoadMore}>
              Loading more ...
            </button>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default BlogPost;
